document.addEventListener('DOMContentLoaded', () => {
  function setupLoadMoreButton(button) {
    // Éviter d'initialiser plusieurs fois le même bouton
    if (button.dataset.loadmoreInitialized === 'true') return;
    button.dataset.loadmoreInitialized = 'true';

    const sectionId = button.dataset.sectionId;
    const grid = document.querySelector(`#CollectionProductGrid-${sectionId}`);
    if (!grid) return;

    const announcer = document.querySelector(`#CollectionLiveAnnouncer-${sectionId}`);

    let isLoading = false;
    let observer;

    async function loadMore() {
      const nextUrl = button.dataset.nextUrl;
      if (!nextUrl || isLoading) return;

      isLoading = true;
      button.disabled = true;
      const initialText = button.textContent;
      button.textContent = 'Chargement...';
      button.setAttribute('aria-busy', 'true');

      try {
        // Construire l’URL de la page suivante
        // nextUrl peut être un chemin ("/collections/...") ou juste une query ("?page=2")
        const url = new URL(nextUrl, window.location.origin + window.location.pathname);

        // Conserver les filtres & le tri actuels UNIQUEMENT si absents dans nextUrl
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach((value, key) => {
          // Ne jamais réécrire page, et ne pas dupliquer les filtres si déjà présents
          if (!url.searchParams.has(key) && key !== 'page') {
            url.searchParams.set(key, value);
          }
        });

        // Demander seulement la section collection
        url.searchParams.set('section_id', sectionId);

        const response = await fetch(url.toString());

        if (!response.ok) {
          console.error(
            'Erreur lors du chargement des produits :',
            response.status,
            response.statusText
          );
          button.disabled = false;
          button.textContent = initialText;
          button.setAttribute('aria-busy', 'false');
          isLoading = false;
          return;
        }

        // Petit délai pour un feedback visuel agréable
        await new Promise((resolve) => setTimeout(resolve, 250));

        const html = await response.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        const newGrid = tmp.querySelector(`#CollectionProductGrid-${sectionId}`);
        const newItems = newGrid ? Array.from(newGrid.children) : [];

        if (!newItems.length) {
          // Plus rien à charger
          if (announcer) {
            announcer.textContent = 'Vous avez atteint la fin des résultats.';
          }
          button.setAttribute('aria-busy', 'false');
          observer.unobserve(button);
          button.remove();
          isLoading = false;
          return;
        }

        newItems.forEach((item) => {
          item.classList.add('product-card-fade-in');
          grid.appendChild(item);
          requestAnimationFrame(() => {
            item.classList.add('loaded');
          });
        });

        if (announcer && newItems.length > 0) {
          const count = newItems.length;
          announcer.textContent =
            count === 1
              ? '1 nouveau produit a été ajouté à la liste.'
              : `${count} nouveaux produits ont été ajoutés à la liste.`;
        }

        // Mettre à jour le bouton à partir de la nouvelle section
        const newButton = tmp.querySelector(`#CollectionLoadMore-${sectionId}`);

        if (newButton && newButton.dataset.nextUrl) {
          button.dataset.nextUrl = newButton.dataset.nextUrl;
          button.disabled = false;
          button.textContent = initialText;
          button.setAttribute('aria-busy', 'false');
          isLoading = false;
        } else {
          // Plus de page suivante
          if (announcer) {
            announcer.textContent = 'Vous avez atteint la fin des résultats.';
          }
          button.setAttribute('aria-busy', 'false');

          // Si le bouton avait le focus, on tente de déplacer le focus vers le premier nouveau produit
          if (document.activeElement === button && newItems.length > 0) {
            const firstNewItem = newItems[0];
            const focusable = firstNewItem.querySelector('a, button');
            if (focusable) {
              focusable.focus();
            }
          }

          observer.unobserve(button);
          button.remove();
        }
      } catch (error) {
        console.error('Erreur load more :', error);
        button.disabled = false;
        button.textContent = initialText;
        button.setAttribute('aria-busy', 'false');
        isLoading = false;
      }
    }

    // 🖱️ Fallback clic (accessibilité, clavier, JS partiel)
    button.addEventListener('click', loadMore);

    // 🌊 Scroll infini : on observe le bouton
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadMore();
          }
        });
      },
      {
        root: null,
        rootMargin: '200px', // on charge un peu avant que le bouton soit vraiment visible
        threshold: 0.1,
      }
    );

    observer.observe(button);
  }

  // Initialisation sur les boutons déjà présents au chargement de la page
  const initialButtons = document.querySelectorAll('[id^="CollectionLoadMore-"]');
  if (initialButtons.length) {
    // On marque le HTML comme "load more actif" → sert à cacher la pagination
    document.documentElement.classList.add('js-load-more-enabled');
    initialButtons.forEach((button) => {
      setupLoadMoreButton(button);
    });
  }

  // Observer global : si une nouvelle section collection est injectée (filtres, tri...),
  // on ré-initialise automatiquement les nouveaux boutons "Charger plus".
  const bodyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // Cas où le noeud lui-même est un bouton load more
        if (node.matches && node.matches('[id^="CollectionLoadMore-"]')) {
          setupLoadMoreButton(node);
        }

        // Cas où des boutons sont à l'intérieur du noeud ajouté
        if (node.querySelectorAll) {
          const newButtons = node.querySelectorAll('[id^="CollectionLoadMore-"]');
          newButtons.forEach((button) => {
            setupLoadMoreButton(button);
          });
        }
      });
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
});
